var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 119 118",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,105.54,47.7904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-35.765L-18.053,-35.765C-27.135,-35.765 -34.498,-28.402 -34.498,-19.319L-34.498,-1.267C-34.498,-0.567 -33.931,0 -33.232,0L-15.179,0C-6.097,0 1.266,-7.364 1.266,-16.446L1.266,-34.499C1.266,-35.198 0.699,-35.765 0,-35.765",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,33.4899,43.5323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-42.657L-5.579,-25.488C-8.385,-16.85 -3.658,-7.572 4.98,-4.765L22.149,0.813C22.814,1.029 23.529,0.665 23.745,0L29.323,-17.169C32.13,-25.807 27.403,-35.085 18.765,-37.891L1.596,-43.47C0.93,-43.686 0.216,-43.322 0,-42.657",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.52201,58.1618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.4L14.605,20.011C21.953,25.35 32.238,23.721 37.576,16.373L48.187,1.768C48.598,1.202 48.473,0.41 47.907,-0.001L33.302,-10.612C25.954,-15.95 15.67,-14.322 10.331,-6.974L-0.28,7.631C-0.691,8.197 -0.566,8.989 0,9.4",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,53.8822,68.8494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,48.467L14.605,37.856C21.953,32.517 23.582,22.233 18.243,14.885L7.632,0.28C7.221,-0.286 6.429,-0.411 5.863,0L-8.741,10.611C-16.089,15.949 -17.718,26.234 -12.38,33.582L-1.769,48.187C-1.358,48.753 -0.566,48.878 0,48.467",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,118.787,64.5463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20.553L-5.579,3.384C-8.385,-5.254 -17.663,-9.981 -26.301,-7.175L-43.47,-1.596C-44.135,-1.38 -44.499,-0.666 -44.283,-0.001L-38.705,17.168C-35.898,25.807 -26.62,30.534 -17.982,27.727L-0.813,22.149C-0.148,21.933 0.216,21.218 0,20.553",
    style: {
      fillRule: "nonzero"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBug);
export default __webpack_public_path__ + "static/media/logo-bug.7b6153d5642100d1a5947dcf3da4718d.svg";
export { ForwardRef as ReactComponent };